<template>
  <div class="conteudoInterno">
    <div class="boxSeta">
      <div class="setaScrollstatic" style="" 
          :class="{ 
            setaScroll: setaScrollState 
            }"
      >
        <button><span><i class="bottom"></i></span></button>
      </div> 
    </div>
    <header class="headerSec">
      <h2>Comentário do CEO</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked"><span><i class="left"></i></span></button>
        <button @click="goNext()" :disabled="clicked"><span><i class="right"></i></span></button>
      </div> 
      <!-- <span></span> -->
    </header>
    <div class="conteudoInternoBox" ref="infoBox">
      <section class="sectionRow" ref="infoscroll">
        <div class="col23ponto5">
          <span class="linecol32"></span> 
          <span class="olho">“A diversidade nos traduz cada vez mais.”</span>
          <br />
        </div> 
        <div class="col40ponto4 marginColBottom">
          <p class="ptreze">
            Serviço, formação, informação e tecnologia. Estes são os pilares da nova UBC, que segue crescendo com a ambição responsável de valorizar cada titular por sua particularidade e potencialidade.
            <br /><br />
            Pessoas são mais importantes que ferramentas e nossa imersão em tecnologia respeita esta verdade. Dados nos ensinam a ler melhor cada titular e o itinerário cada vez mais febril de suas obras num mundo globalizado e pulverizado em muitas plataformas, senhas, códigos e identificadores.
            <br /><br />
            A cultura da UBC é a de abraçar as transformações com um olhar proativo, de fazer parte de uma rede que tem sede por mais informação, mais contato, mais interação. A diversidade nos traduz cada vez mais. Estamos presentes em todo o Brasil e no mundo inteiro, através de nossos contratos bilaterais e unilaterais, na representação de nosso repertório e criadores.
            <br /><br />
            O ano de 2018 foi intenso. Renovamos contratos importantes, consolidamos ainda mais nosso futuro digital incorporando novos acordos, aperfeiçoando outros. Consequentemente, o número de titulares beneficiados cresceu. O acordo com todas as cadeias de cinema (com exceção do Cinemark) foi outra vitória coletiva vital, com impacto econômico instantâneo no exercício 2018.
            <br /><br />
            Temos muitos desafios pela frente. A gestão coletiva participa como uma das protagonistas no novo ecossistema da música e, para validar esta realidade, é preciso mudar, se reinventar, incorporar novas práticas e governanças. Queremos mais, queremos o melhor para nossos titulares e parceiros locais e globais.
          </p>
          <br />
          <p class="assCeo">Marcelo Castello Branco</p>
        </div>
        <div class="col32">
          <img style="width:100%;" src="../assets/ceo.jpg" alt="CEO" title="CEO" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComentarioCeo',
  props:['clicked'],
  data() {
    return{
      setaScrollState: false,
    }
  },
  destroyed(){  
    this.myStopFunction();
  },
  mounted () {
   this.showSetaScroll();
  },
  methods:{
    showSetaScroll: function(){
      this.refresh = setInterval(() => {
        let alturaTela = window.innerHeight;
        let alturaDiv = this.$refs.infoBox.clientHeight;
        let boxABB = this.$refs["infoscroll"].getBoundingClientRect();
        if(alturaTela - 10 <= alturaDiv && boxABB.top == 148){
          this.setaScrollState = true
        }else{
          this.setaScrollState = false
        }
      }, 1000);
    },
    myStopFunction: function() {
      clearInterval(this.refresh);
    },
    goNext: function(){
      this.$emit("go-next");
    },
    goBack: function(){
      this.$emit("go-back");
    },  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ComentarioCeo.vue